(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlm-hb-review-mosaic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nelmoro-reviews')) {
  customElements.define('nelmoro-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) this.cleanup();
      const controller = new AbortController();
      const signal = controller.signal;
      const cards = Array.from(this.querySelectorAll('.nlm-reviews-mosaic__card'));
      const grid = this.querySelector('.nlm-reviews-mosaic__grid');
      const more = this.querySelector('[data-reviews-more]');
      const mobile = window.matchMedia('(max-width: 599px)');
      const batch = () => Number(mobile.matches ? this.dataset.mobileCount : this.dataset.desktopCount);
      let visible = batch();
      let expanded = false;
      let frame;
      const layout = () => {
        cards.forEach(card => {
          if (card.hidden) return;
          const span = 'span ' + Math.ceil(card.getBoundingClientRect().height + 24);
          if (card.style.gridRowEnd !== span) card.style.gridRowEnd = span;
        });
      };
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(layout); };
      const update = () => {
        cards.forEach((card,index) => { card.hidden = index >= visible; });
        more.hidden = visible >= cards.length;
        layout();
      };
      this.classList.add('is-enhanced');
      update();
      more.addEventListener('click', () => {
        const previous = visible;
        expanded = true;
        visible = Math.min(cards.length, visible + batch());
        update();
        this.querySelector('[data-reviews-status]').textContent = this.dataset.moreMessage;
        if (cards[previous]) cards[previous].focus({preventScroll:true});
      }, {signal});
      mobile.addEventListener('change', () => {
        visible = expanded ? Math.max(visible,batch()) : batch();
        update();
      }, {signal});
      const observer = new ResizeObserver(schedule);
      observer.observe(grid);
      cards.forEach(card => observer.observe(card));
      this.querySelectorAll('.nlm-reviews-mosaic__photo').forEach(image => image.addEventListener('load',schedule,{signal}));
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-review-open]');
      opener.addEventListener('click', () => dialog.showModal(), {signal});
      this.querySelector('[data-review-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, {signal});
      dialog.addEventListener('close', () => opener.focus({preventScroll:true}), {signal});
      this.querySelectorAll('.nlm-review-dialog__star-picker input').forEach(input => {
        input.addEventListener('change', () => {
          this.querySelectorAll('[data-rating-label]').forEach(label => label.classList.toggle('is-filled', Number(label.dataset.ratingLabel) > 0 && Number(label.dataset.ratingLabel) <= Number(input.value)));
        }, {signal});
      });
      if (this.querySelector('[data-review-feedback]')) dialog.showModal();
      this.cleanup = () => { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); };
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
